import React, { useState, useEffect } from "react";
import './PageLoader.css'; // Import CSS file for styling

function PageLoader() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate a loading delay of 2 seconds
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`page-loader ${loading ? 'loading' : ''}`}>
      <div className="loader"></div>
    </div>
  );
}

export default PageLoader;
